import shuffle from 'lodash.shuffle';
import { isAttempted } from 'store/questions/selectors';
import { QuestionsState } from 'store/questions/types';
import { NAVIGATION_ITEM_ICON_NAMES } from 'constants/common';
import { FONT_SIZE } from 'constants/components';

export const shuffleAnswerOptions = (answerOptions: any[]): any[] => {
  if (answerOptions.length <= 1) {
    return answerOptions;
  }

  let shuffledArray = shuffle(answerOptions);
  let iterationCount = 0;

  const MAX_RETRIES = 10;

  while (
    JSON.stringify(shuffledArray) === JSON.stringify(answerOptions) &&
    iterationCount < MAX_RETRIES
  ) {
    iterationCount++;
    shuffledArray = shuffle(shuffledArray);
  }

  return shuffledArray;
};

export const getAttemptedCount = (questions: Array<QuestionsState>): number =>
  questions.filter((question: any) => isAttempted(question)).length;

export const getQuestionIconSize = (iconName: string): number => {
  if (iconName === NAVIGATION_ITEM_ICON_NAMES.QUESTION) {
    return FONT_SIZE.SEVEN;
  }
  if (iconName === 'survey') {
    return FONT_SIZE.EIGHT;
  }

  return FONT_SIZE.SIX;
};

export default shuffleAnswerOptions;
